<div class="page-container">
  <div class="page-body-container">
    <div class="inner-content">
      <div class="card col-span-12">
        <div class="card-header-container justify-between!">
          <div class="flex flex-col">
            <h1 class="card-header">Rezept erstellen</h1>
            @if (patient) {
              <h5 class="text-sm">{{ patient.title }} {{ patient.firstName }} {{ patient.lastName }}</h5>
              <h5 class="text-sm">{{ patient.deliveryAddress.street }} {{ patient.deliveryAddress.houseNumber }}</h5>
              <h5 class="text-sm">{{ patient.deliveryAddress.zipCode }} {{ patient.deliveryAddress.city }}</h5>
            }
          </div>
          <div class="flex flex-col gap-2">
            <div class="flex items-center gap-6">
              <mat-checkbox [(ngModel)]="showOnlyAvailableArticles" (ngModelChange)="changeAvailableState()">Nur
                verfügbare Artikel anzeigen
              </mat-checkbox>
              <div class="flex flex-col min-w-[150px]">
                <label class="text-[10px] font-bold text-app-primary-10 uppercase mb-1">THC Gehalt ({{thcMin}}% - {{thcMax}}%)</label>
                <mat-slider min="0" max="30" step="1" discrete>
                  <input matSliderStartThumb [(ngModel)]="thcMin" (change)="onThcChange()">
                  <input matSliderEndThumb [(ngModel)]="thcMax" (change)="onThcChange()">
                </mat-slider>
              </div>
              <div class="flex flex-col min-w-[150px]">
                <label class="text-[10px] font-bold text-app-primary-10 uppercase mb-1">CBD Gehalt ({{cbdMin}}% - {{cbdMax}}%)</label>
                <mat-slider min="0" max="30" step="1" discrete>
                  <input matSliderStartThumb [(ngModel)]="cbdMin" (change)="onCbdChange()">
                  <input matSliderEndThumb [(ngModel)]="cbdMax" (change)="onCbdChange()">
                </mat-slider>
              </div>
              <div class="flex flex-col min-w-[150px]">
                <label class="text-[10px] font-bold text-app-primary-10 uppercase mb-1">Preis pro g ({{priceMin}}€ - {{priceMax}}€)</label>
                <mat-slider min="0" max="30" step="1" discrete>
                  <input matSliderStartThumb [(ngModel)]="priceMin" (change)="onPriceChange()">
                  <input matSliderEndThumb [(ngModel)]="priceMax" (change)="onPriceChange()">
                </mat-slider>
              </div>
              <div class="form-group">
                <div class="form-control">
                  <input [formControl]="filterControl" matInput (keyup)="applyFilter()" placeholder="Suche">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="grid lg:grid-cols-2 grid-cols-1 gap-8">
          @if (selectedArticlesFormArray && selectedArticlesFormArray.controls && selectedArticlesFormArray.controls.length > 0) {
            <div class="card-content article-list">
              <form [formGroup]="prescriptionForm">
                <div formArrayName="selectedArticles">
                  @for (selectedCtrl of selectedArticlesFormArray.controls; track selectedCtrl; let j = $index) {
                    <div
                      [formGroupName]="j"
                      class="article-tile w-full bg-canna-accordion-background px-8 py-4 flex flex-col mb-8 border-b border-canna-primary">
                      <div class="article-info flex gap-4">
                        <h1>{{ selectedCtrl.value.articleName }}
                          [{{ selectedCtrl.value.articleNumber }}
                        ]</h1>
                        @if (selectedCtrl.value.variantName) {
                          <span>Variante: {{ selectedCtrl.value.variantName }}</span>
                        }
                        <div class="text-xs self-center">
                          Nettopreis: {{ selectedCtrl.value.nettoPrice | number: '1.2-2': 'de-DE' }}
                          €
                        </div>
                      </div>
                      <div class="flex gap-4 mt-8">
                        <div class="form-group mt-4">
                          <div class="form-control relative">
                            <input type="number" formControlName="quantityToAdd" matInput
                              placeholder="Menge">
                            <div
                              class="absolute right-12 top-2"> x {{selectedCtrl.value.bindingSize}}{{ selectedCtrl.value.unitOfMeasurement.shortName }}
                            </div>
                          </div>
                        </div>
                        <button type="button" class="btn-rounded self-center"
                          (click)="updateSelectedArticles(selectedCtrl)">
                          <i class="fa-solid fa-arrows-rotate icon-center"></i>
                        </button>
                        <button class="btn-rounded delete self-center"
                          (click)="removeSelectedArticle(j, selectedCtrl)">
                          <i class="fa-solid fa-times icon-center"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </form>
              @if (selectedArticlesFormArray.controls && selectedArticlesFormArray.controls.length > 0) {
                @for (
                  selectedArticle of selectedArticlesFormArray.controls; track selectedArticle.value.articleNumber) {
                  <div class="grid grid-cols-3">
                    <div class="text-xs px-2">{{ selectedArticle.value.articleName }}</div>
                    <div class="text-xs px-2">
                      Menge: {{ selectedArticle.value.quantity }}  x {{selectedArticle.value.bindingSize}}{{ selectedArticle.value.unitOfMeasurement.shortName }}
                    </div>
                    <div class="grid grid-cols-2">
                      <div class="text-xs px-2">
                        Nettopreis:
                      </div>
                      <div class="text-xs text-right px-2">
                        {{ selectedArticle.value.nettoPrice * selectedArticle.value.quantity | currency: 'EUR': 'symbol': '1.2-2' }}
                      </div>
                    </div>

                  </div>
                }
              }
              <div class="border-t border-canna-primary">
                <div class="grid grid-cols-3">
                  <div></div>
                  <div></div>
                  <div class="grid grid-cols-2">
                    <div class="text-xs px-2">
                      MwSt:
                    </div>
                    <div class="text-xs text-right px-2">
                      {{ getTotalPrice() * .19 | currency: 'EUR': 'symbol': '1.2-2' }}
                    </div>
                    <div class="text-xs px-2">
                      Gesamtpreis:
                    </div>
                    <div class="text-xs text-right px-2">
                      {{ getTotalPrice() * 1.19 | currency: 'EUR': 'symbol': '1.2-2' }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

          } @else {
            <div class="card-content article-list">
              <h1 class="text-center">Noch keine Artikel für das Rezept gewählt</h1>
            </div>
          }
          @if (articlesFormArray.controls && articlesFormArray.controls.length > 0) {
            <div class="card-content article-list">
              <form [formGroup]="prescriptionForm">
                <div formArrayName="articles">
                  @for (articleCtrl of articlesFormArray.controls; track articleCtrl; let i = $index) {
                    <div
                      [formGroupName]="i"
                      class="article-tile w-full bg-canna-accordion-background px-8 py-4 flex flex-col mb-8 border-b border-canna-primary">
                      <div class="article-info flex gap-4">
                        <h1>{{ articleCtrl.value.articleName }}
                          [{{ articleCtrl.value.articleNumber }}
                        ]</h1>
                        @if (articleCtrl.value.variantName) {
                          <span>Variante: {{ articleCtrl.value.variantName }}</span>
                        }
                        <div class="text-xs self-center">Verfügbare
                          Menge: {{ articleCtrl.value.quantity }} x {{articleCtrl.value.bindingSize}}{{ articleCtrl.value.unitOfMeasurement.shortName }}
                        </div>
                        <div class="text-xs self-center">
                          Nettopreis: {{ articleCtrl.value.nettoPrice | number: '1.2-2': 'de-DE' }}
                          €
                        </div>
                      </div>
                      <div class="flex items-center gap-2 mt-2">
                          @if (articleCtrl.value.thc) {
                              <span class="text-[10px] bg-red-50 text-red-600 px-1.5 py-0.5 rounded font-bold">THC: {{ articleCtrl.value.thc }}%</span>
                          }
                          @if (articleCtrl.value.cbd) {
                              <span class="text-[10px] bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded font-bold">CBD: {{ articleCtrl.value.cbd }}%</span>
                          }
                          @if (articleCtrl.value.genetic) {
                              @for (gen of articleCtrl.value.genetic; track gen) {
                                  <span class="text-[10px] bg-green-50 text-green-700 px-1.5 py-0.5 rounded font-bold">{{ gen.name }}</span>
                              }
                          }
                          @if (articleCtrl.value.conditions) {
                              @for (cond of articleCtrl.value.conditions; track cond) {
                                  <span class="text-[10px] bg-purple-50 text-purple-700 px-1.5 py-0.5 rounded font-bold">{{ cond.name }}</span>
                              }
                          }
                      </div>
                      <div class="flex gap-4 mt-8">
                        <div class="form-group mt-4">
                          <div class="form-control relative">
                            <input type="number" formControlName="quantityToAdd" matInput
                              placeholder="Menge">
                            <div
                              class="absolute right-12 top-2"> x {{articleCtrl.value.bindingSize}}{{ articleCtrl.value.unitOfMeasurement.shortName }}
                            </div>
                          </div>
                        </div>
                        <button type="button" class="btn-rounded self-center"
                          (click)="updateSelectedArticles(articleCtrl)">
                          <i class="fa-solid fa-plus icon-center"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              </form>
            </div>
          }
        </div>

        <div class="card-footer">
          <div class="space">

            <button class="btn-primary" (click)="prescriptionReview()">Folgerezept anfragen</button>

          </div>
          <div class="space">
            @if (actualPaging) {
              <div class="paginator">
                <mat-paginator
                  [length]="actualPaging.totalItems"
                  [pageSize]="actualPaging.pageSize"
                  [pageIndex]="actualPaging.pageNumber - 1"
                  showFirstLastButtons
                  [pageSizeOptions]="[5, 10, 15, 20]"
                  (page)="onPageChange($event)"
                ></mat-paginator>

              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
